import ColorPicker from '@anm/components/ColorPicker';
import Dropdown from '@anm/components/Dropdown';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';

import { ColorField, ColorInput, ColorPreview, Wrapper } from './Wrapper';
import { useColorPickerField } from './hooks';
import { ColorPickerFieldProps } from './types';

export * from './types';

const ColorPickerField: FC<ColorPickerFieldProps> = ({
  direction,
  variant = 'left',
  withTextInput,
  onFastColorChange,
  ...props
}) => {
  const [color, inputRef, handleBlur, handleFocus, handleChangeColor, handleColorPickerChange] = useColorPickerField(
    props
  );
  const colorPickerDirection = direction || (isMobileOrIPad() ? 'to-bottom' : 'to-left-no-arrow');

  const inputProps = {
    inputRef,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChangeColor,
    value: color.toUpperCase()
  };

  return (
    <Wrapper {...{ variant }}>
      <ColorField>
        <ColorPreview {...{ variant }} color={props.initialColor}>
          <Dropdown
            autoClose={false}
            isModalOnMobile={false}
            direction={colorPickerDirection}
            openByAction="click"
            openerVariant="transparent_square"
            renderContent={({ isOpenContent, closeDropdown }) =>
              isOpenContent ? (
                <ColorPicker
                  initialColor={color}
                  onColorChange={handleColorPickerChange}
                  withTextInput={withTextInput}
                  closeDropdown={closeDropdown}
                  onFastColorChange={onFastColorChange}
                  {...inputProps}
                />
              ) : null
            }
          />
        </ColorPreview>
        {variant !== 'square' && <ColorInput type="text" {...inputProps} ref={inputRef} />}
      </ColorField>
    </Wrapper>
  );
};

export default ColorPickerField;
